var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container",style:({
		'padding-left': _vm.$store.state.isOpenSideBar ? '260px' : '0px'
	})},[_c('top'),_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"section__content section__content--p30"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }